import { findAreaById } from "../actions/AreaHelper";
import useFindDevice from "../hooks/useFindDevice";
import { translate } from "../locales/translate";
import Scenario from "../viewModels/Scenario";
var moment = require("moment-jalaali");
const runResultHandler = (
  runResult: any,
  scenarios: any,
  devices = [],
  areas = []
) => {
  const {
    didRun,
    dueDate,
    conditionsCheckResult,
    scenarioUId: scenarioRunUId,
    scenarioId: scenarioRunId,
  } = runResult;
  var _toastDetail = null;

  var findScenario = scenarios.find(
    (scenario: any) =>
      (scenario.uId && scenario.uId == scenarioRunUId) ||
      scenario.id == scenarioRunId
  );
  // === toast detail generator ===
  const toastDetail = (
    title = "",
    status = "info",
    description = {} || null,
    duration = 3500,
    isClosable = true,
    countDown = 0
  ) => {
    var toastDetail = {
      title,
      variant: "top-accent",
      status,
      description,
      duration,
      isClosable,
      countDown,
      scenarioRunUId,
    };
    return toastDetail;
  };
  if (findScenario) {
    const scenarioName = findScenario.name;
    // === The scenario was executed successfully ===
    if (didRun) {
      _toastDetail = toastDetail(
        translate("scenario.scenarioRunResult.didRun", { scenarioName }),
        "success",
        null,
        3500,
        false
      );
      // === The execution of the scenario encountered an error ===
    } else if (dueDate) {
      const date = moment(dueDate).format("jYYYY/jM/jD");
      const time = moment(dueDate).format("HH:mm:ss");
      const countDown =
        (new Date().getTime() - new Date(dueDate).getTime()) / 1000;
      _toastDetail = toastDetail(
        translate("scenario.scenarioRunResult.dueDate", {
          scenarioName,
          date,
          time,
        }),
        "info",
        null,
        3500,
        true,
        countDown
      );
    } else {
      // === error with unresolved Conditions
      if (!conditionsCheckResult.result) {
        const unResolvedConditions = conditionsCheckResult.unResolvedConditions;
        var modelScenario = Object.assign(new Scenario(), findScenario);
        // === find Area for areaName and deviceName ===
        if (areas || devices) {
          unResolvedConditions.forEach((element: any) => {
            // === find area by areaUId
            // const findArea: any =
            //   areas &&
            //   areas.find((area: any) => area.areaUId == element.areaUId);
            const findArea: any = findAreaById(areas, element.areaUId);

            // === find device by deviceUId
            // const findDeice: any = devices.find(
            //   (device: any) => device.deviceUId == element.deviceUId
            // );
            const findDeice: any = useFindDevice(devices, element.deviceUId);
            // === assign areaName to unResolvedConditions
            if (findArea) {
              unResolvedConditions[
                unResolvedConditions.indexOf(element)
              ].areaName = findArea?.areaName;
              // === find Area State ===
              if (element.stateUId) {
                const findAreaState = findArea?.userDefinedStates.find(
                  (areaState: any) => areaState.uId == element.stateUId
                );
                if (findAreaState) {
                  unResolvedConditions[
                    unResolvedConditions.indexOf(element)
                  ].stateName = findAreaState?.name;
                }
              }
            }
            // === assign deviceName to unResolvedConditions
            if (findDeice) {
              unResolvedConditions[
                unResolvedConditions.indexOf(element)
              ].deviceName = findDeice?.deviceName;
            }
          });
        }
        modelScenario.conditions = unResolvedConditions;
        const _summary = [];
        _summary.push(
          modelScenario.getOptionalConditions().map((c: any) => c.getSummary())
        );
        _toastDetail = toastDetail(
          translate("scenario.scenarioRunResult.unResolvedConditions", {
            scenarioName,
          }),
          "error",
          _summary,
          5000
        );
      }
    }
  }
  return _toastDetail;
};

export default runResultHandler;
